<template>
    <div class="Administration">
        <el-row>
            <el-col :span="3">
                <el-button type="primary" @click="AddCreditCard">新增信用卡</el-button>
            </el-col>
            <el-col :span="7">
                <el-input v-model="search" placeholder="全字段搜索" style="width:80%;"></el-input>
                <el-button type="primary" @click="GetCreditCardList()" style="margin-left:10px;">搜索</el-button>
            </el-col>
        </el-row>
        <el-row class="margin-top2" style="margin-bottom:50px;">
            <el-table :data="tableData" :header-cell-style="headClass" border style="width: 100%">
                <el-table-column prop="name" label="信用卡持有人" align="center" width="160px">
                    <template slot-scope="scope">
                        <p>{{scope.row.cardholderName}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Cardnumber" label="信用卡号" align="center" width="200px">
                    <template slot-scope="scope">
                        <p>{{scope.row.bankNumber}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Bank" label="开户银行" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.bankName}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Bank" label="状态" align="center" width="80px">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status == 1">正常</p>
                        <p v-else-if="scope.row.status == 0" style="color:red">停用</p>
                    </template>
                </el-table-column>
                <el-table-column prop="bill" label="账单日" width="80" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.billDate}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="repayment" label="还款日" width="80" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.repaymentDate}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Effective" label="有效期" width="80" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.expirationDate}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="time" label="创建时间" align="center" width="180px">
                    <template slot-scope="scope">
                        <p>{{scope.row.createTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="绑定店铺" align="center">
                    <template slot-scope="scope">
                        <el-collapse v-for="(ele,i) in scope.row.sellers" :key="i">
                            <el-row type="flex" align="middle" justify="space-between">
                                <el-collapse-item :title="ele.shop_name" align="center" id="TetleColor">
                                    <div
                                        class="line-height"
                                        v-for="(item,i) in ele.countryMarks"
                                        :key="i"
                                    >{{item.countryName}}</div>
                                </el-collapse-item>
                                <el-button type="primary" @click="SolutionStore(scope.row)" style="height:27.13px">解绑</el-button>
                            </el-row>
                        </el-collapse>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button @click="Edit(scope.row)" type="primary" size="small">编辑</el-button>
                        <el-button @click="handleClick(scope.row)" type="success" size="small">绑定店铺</el-button>
                        <el-button @click="delet(scope.row.id)" type="danger" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pagesize1"
                    :current-page="currentPage1"
                    :total="total1"
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                ></el-pagination>
            </div>
        </el-row>
        <AddCreditCard ref="AddCreditCard" @refresh="refresh" />

        <el-dialog title="绑定店铺" :visible.sync="dialogTableVisible" width="40%">
            <el-row class="border-bottom padding">
                <el-col :span="24" class="line-height padding">
                    <el-col :span="15">
                        <el-input v-model="search1" placeholder="搜索店铺名称"></el-input>
                    </el-col>
                    <el-col :span="5" :offset="1">
                        <el-button type="primary" @click="createClick()">搜索</el-button>
                    </el-col>
                </el-col>
            </el-row>
            <div class="table">
            <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                :data="tableData1"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%;"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="binding" label="是否已绑定信用卡" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.isHasString}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="店铺名称" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.shop_name}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="商户ID" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.sellerId}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="站点" align="center">
                    <template slot-scope="scope">
                        <el-collapse v-for="(ele,i) in scope.row.countryMarks" :key="i">
                            <template>
                                <p>{{ele.countryName}}</p>
                            </template>
                        </el-collapse>
                    </template>
                </el-table-column>
            </el-table>
            <div class="inpage">
            <el-pagination
                style="margin-top: 16px; text-align:center;"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 50, 100, 250]"
                :page-size="pagesize"
                :current-page="currentPage"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
            </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑信用卡" :visible.sync="EditCard" width="30%">
        <el-row class="border-bottom padding">
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">信用卡持有人：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.name"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">开户银行：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.Bank"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">信用卡号：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.Cardnumber"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">账单日：</el-col>
                <el-col :span="15">
                    <el-select v-model="ACreditCard.bill" placeholder="请选择" style="width:100%;">
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">还款日：</el-col>
                <el-col :span="15">
                    <el-select
                        v-model="ACreditCard.repayment"
                        placeholder="请选择"
                        style="width:100%;"
                    >
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">有效日期：</el-col>
                <el-col :span="15">
                    <el-date-picker
                        @change="Time"
                        v-model="ACreditCard.Effective"
                        type="month"
                        placeholder="选择月"
                        style="width:100%;"
                    ></el-date-picker>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">状态：</el-col>
                <el-col :span="15">
                    <el-radio-group v-model="ACreditCard.status">
                        <el-radio :label="0">停用</el-radio>
                        <el-radio :label="1">正常</el-radio>
                    </el-radio-group>
                </el-col>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="EditCard = false">取 消</el-button>
            <el-button type="primary" @click="Editsave()">提 交</el-button>
        </div>
    </el-dialog>

    </div>
</template>

<script>
import AddCreditCard from "./Administrationframe/AddCreditCard";
import Boundshop from "./Administrationframe/Boundshop";
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "Administration",
    components: {
        AddCreditCard,
        Boundshop
    },
    data() {
        return {
            headClass: this.common.headClass,
            search: "",
            tableData: [],
            ACreditCard: {
                name: "",
                Bank: "",
                Cardnumber: "",
                bill: "",
                repayment: "",
                Effective: "",
                status: ""
            },

            search1: "",
            dialogTableVisible: false,
            EditCard:false,

            currentPage: 1,
            pagesize: 5,
            size: 5,
            total: 0,

            currentPage1: 1,
            pagesize1: 50,
            size1: 50,
            total1: 0,

            tableData1: [],
            list: [],
            ShopId: [],
            sellerData: "",
            isHas: "",
            multipleSelection: "",
            values: "",
            EditId:""
        };
    },
    mounted() {},
    created() {
        this.GetCreditCardList();
    },
    watch: {
        dialogTableVisible(oldname, newname) {
            console.log(oldname, newname);
            if (oldname == true) {
                setTimeout(() => {
                    this.initselect();
                }, 100);
            }
        }
    },
    methods: {
        refresh() {
            this.GetCreditCardList();
        },
        SolutionStore(item) {
            var parameter = {
                id: item.creditSellers[0].id
            };
            ajaxPost(
                Baseurl + "creditCardController/UntieCardSeller",
                parameter
            ).then(res => {
                console.log(res)
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "解绑成功!"
                    });
                    this.GetCreditCardList();
                }
            })
        },
        GetCreditCardList() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                page: this.currentPage1,
                size: this.size1,
                companyId: role.company_id,
                searchStr: this.search
            };
            ajaxPost(
                Baseurl + "creditCardController/selectCreditCards",
                parameter
            ).then(res => {
                this.tableData = res.data.data.list;
                this.total1 = res.data.data.total;
            });
        },
        AddCreditCard() {
            this.$refs.AddCreditCard.init();
        },
        handleClick(value) {
            this.dialogTableVisible = true;
            console.log(value, "value");
            this.values = value;
            var role = JSON.parse(window.localStorage.getItem("role"));
            this.search1 = ""
            this.createClick()
        },
        createClick() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                sellerIds: this.values.sellerIds,
                page: this.currentPage,
                size: this.size,
                shop_name: this.search1,
                company_id: role.company_id
            };
            ajaxPost(
                Baseurl + "sellerController/selectAllSeller",
                parameter
            ).then(res => {
                this.tableData1 = res.data.data.list;
                this.total = res.data.data.total
            });
        },
        delet(value) {
            this.$confirm(
                "此操作将删除信用卡相关的所有信息, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    var TheId = { id: value };
                    ajaxPost(
                        Baseurl + "creditCardController/deleteCreditCard",
                        TheId
                    ).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            this.GetCreditCardList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },

        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex < 4) {
                if (row.span_num > 0) {
                    return {
                        rowspan: row.span_num,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        initselect() {
            var rows = new Array();
            for (var i = 0; i < this.tableData1.length; i++) {
                if (this.tableData1[i].isHasString == "已绑定") {
                    rows.push(this.tableData1[i]);
                }
            }
            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        },
        aaa() {
            alert();
        },
        toggleSelection(rows) {
            console.log(rows);
            // this.tableData1[0]
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                    console.log(row, "roweach");
                });
            }
        },
        handleSelectionChange(val) {
            this.multipleTable = val;
            console.log(this.multipleTable)
        },
        save() {
            for (var i = 0; i < this.multipleTable.length; i++) {
                this.ShopId.push({ id: this.multipleTable[i].id });
            }
            var obj = {
                id: this.values.id,
                sellers: this.ShopId
            };
            // console.log(obj)
            ajaxPost(
                Baseurl + "creditCardController/creditCardBingSeller",
                obj
            ).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "绑定店铺成功"
                    });
                    this.GetCreditCardList();
                } else {
                    this.$message.error(res.data.data);
                }
            });
            this.ShopId = [];
            this.dialogTableVisible = false;
        },
        handleSizeChange(val) {
            this.size = val;
            this.createClick()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.createClick()
        },
        handleSizeChange1(val) {
            this.size1 = val;
            this.GetCreditCardList()
        },
        handleCurrentChange1(val) {
            this.currentPage1 = val;
            this.GetCreditCardList()
        },
        Time(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1);
            this.ACreditCard.Effective = datetime;
            console.log(this.ACreditCard.Effective);
        },
        Edit(val){
            this.EditCard = true
            this.ACreditCard.name = val.cardholderName
            this.ACreditCard.Bank = val.bankName
            this.ACreditCard.Cardnumber = val.bankNumber
            this.ACreditCard.bill = val.billDate
            this.ACreditCard.repayment = val.repaymentDate
            this.ACreditCard.Effective = val.expirationDate
            this.ACreditCard.status = val.status
            this.EditId = val.id
        },
        Editsave(){
            var obj = {
                id: this.EditId,
                cardholderName: this.ACreditCard.name,
                bankName: this.ACreditCard.Bank,
                bankNumber: this.ACreditCard.Cardnumber,
                billDate: this.ACreditCard.bill,
                repaymentDate: this.ACreditCard.repayment,
                expirationDate: this.ACreditCard.Effective,
                status: this.ACreditCard.status
            };
            ajaxPost(Baseurl + "creditCardController/updateCreditCardsById",obj).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "编辑信用卡信息成功"
                    });
                    this.GetCreditCardList();
                } else {
                    this.$message.error(res.data.data);
                }
                this.EditCard = false
            });
        },

    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-collapse {
        border-top: none;
        border-bottom: none;
    }
    .el-collapse-item__header {
        border-bottom: none;
        background: none !important;
    }
    .el-collapse-item__wrap {
        border-bottom: none;
        background: none !important;
    }
    .el-collapse-item__content {
        padding-bottom: 0px;
    }
    .el-dialog__body {
        padding: 13px 20px;
    }
}
.line-height {
    line-height: 30px;
}
.padding {
    padding: 5px 0;
}
// .inpage{
//     position: fixed;
//     bottom: 0;
// }
// .table{
//     width: 100%;
//     height: 500px;
//     position: relative;
// }
.page {
        position: fixed;
        width: 100%;
        bottom: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        z-index: 99;
    }
</style>